import { render, staticRenderFns } from "./VueVegaEmbed.vue?vue&type=template&id=78d340fa&"
import script from "./VueVegaEmbed.vue?vue&type=script&lang=ts&"
export * from "./VueVegaEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports